import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import './Models.css';

const MODELS = [
  { key: 'mantaray420', name: 'MANTA RAY 420', image: '/unimar-manta-ray-420.webp', length: '4.2 m', maxHp: '50 HP', passengers: '5' },
  { key: 'stia580',     name: 'STIA 580',      image: '/unimar-stia-580.webp',       length: '5.76 m', maxHp: '140 HP', passengers: '6' },
  { key: 'real500',     name: 'REAL 500',       image: '/unimar-real-500.webp',       length: '5.0 m', maxHp: '100 HP', passengers: '6' },
];

function Models() {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  const handleTabClick = (index) => {
    setTransitioning(true);
    setTimeout(() => {
      setActiveIndex(index);
      setTimeout(() => setTransitioning(false), 50);
    }, 400);
  };

  const model = MODELS[activeIndex];

  return (
    <div className="models-page">
      <SEO
        title="Boat Models — Manta Ray 420, STIA 580, Real 500"
        description="Explore the full Unimar boat lineup. The Manta Ray 420 center console, STIA 580 bowrider, and Real 500 deck boat — all CE certified fiberglass boats built in North Macedonia."
        url="/models"
        image="/unimar-boats-collection.webp"
      />
      <Header />
      <section className="models-explorer">
        <div className="models-explorer__bg" />
        <div className="models-explorer__content">
          <div className="models-explorer__tabs">
            {MODELS.map((m, i) => (
              <button
                key={m.key}
                className={`models-explorer__tab ${i === activeIndex ? 'models-explorer__tab--active' : ''}`}
                onClick={() => handleTabClick(i)}
              >
                {m.name}
              </button>
            ))}
          </div>

          <div className="models-explorer__right" data-transitioning={transitioning}>
            <div className="models-explorer__image">
              <img alt={model.name} src={model.image} className={model.key === "real500" ? "is-flipped" : ""} />
            </div>
            <div className="models-explorer__info">
              <h2 className="models-explorer__name">{model.name}</h2>
              <span className="models-explorer__type">{t(`modelsPage.${model.key}.type`)}</span>
              <p className="models-explorer__desc">{t(`modelsPage.${model.key}.desc`)}</p>
              <div className="models-explorer__specs">
                <div className="models-explorer__spec">
                  <span className="models-explorer__spec-label">{t('modelsPage.length')}</span>
                  <span className="models-explorer__spec-value">{model.length}</span>
                </div>
                <div className="models-explorer__spec">
                  <span className="models-explorer__spec-label">{t('modelsPage.maxHp')}</span>
                  <span className="models-explorer__spec-value">{model.maxHp}</span>
                </div>
                <div className="models-explorer__spec">
                  <span className="models-explorer__spec-label">{t('modelsPage.passengers')}</span>
                  <span className="models-explorer__spec-value">{model.passengers}</span>
                </div>
              </div>
              <div className="models-explorer__actions">
                <a href={`/models/${model.key}`} className="models-explorer__btn models-explorer__btn--primary">
                  {t('modelsPage.viewModel')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Models;
